import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import httpRequest from "../../services/httpRequest";
import snakecaseKeys from "snakecase-keys";

const _url = "/client/medication";

export const fetchAllMedications = createAsyncThunk(
  "medication/fetchAllMedications",
  async (clientId) => {
    const result = await httpRequest({ url: `${_url}/all/${clientId}`, method: "GET" });
    if (!result) return;
    return result.data;
  }
);

export const saveMedication = createAsyncThunk(
  "medication/saveMedication",
  async (data) => {
    const result = await httpRequest({
      url: _url,
      method: "POST",
      data: snakecaseKeys(data, { deep: true }),
      successMessage: data.id ? "Medication updated successfully" : "Medication added successfully",
    });
    if (!result) return;
    return result.data;
  }
);

export const deactivateMedication = createAsyncThunk(
  "medication/deactivateMedication",
  async (id) => {
    const result = await httpRequest({
      url: `${_url}/${id}`,
      method: "DELETE",
      successMessage: "Medication removed successfully",
    });
    if (!result) return;
    return id;
  }
);

const medicationSlice = createSlice({
  name: "medication",
  initialState: { list: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllMedications.pending, (state) => { state.loading = true; })
      .addCase(fetchAllMedications.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchAllMedications.rejected, (state) => { state.loading = false; })
      .addCase(saveMedication.fulfilled, (state, action) => {
        if (!action.payload) return;
        const idx = state.list.findIndex((m) => m.id === action.payload.id);
        if (idx >= 0) state.list[idx] = action.payload;
        else state.list.push(action.payload);
      })
      .addCase(deactivateMedication.fulfilled, (state, action) => {
        state.list = state.list.filter((m) => m.id !== action.payload);
      });
  },
});

export const getMedications = (state) => state.medication.list;
export const getMedicationsLoading = (state) => state.medication.loading;

export default medicationSlice.reducer;
